import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { setAuthPromptCallback } from "@/lib/api";
import Layout from "@/components/Layout";
import AuthModal from "@/components/AuthModal";
import OnboardingFlow from "@/components/OnboardingFlow";
import AuthPage from "@/pages/AuthPage";
import HomePage from "@/pages/HomePage";
import CheckInPage from "@/pages/CheckInPage";
import CalmToolsPage from "@/pages/CalmToolsPage";
import AffirmationsPage from "@/pages/AffirmationsPage";
import TalkPage from "@/pages/TalkPage";
import JournalPage from "@/pages/JournalPage";
import UnderstandPage from "@/pages/UnderstandPage";
import SupportPage from "@/pages/SupportPage";

function AppContent() {
  const { user, loading, promptAuth } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);

  // Wire up the API interceptor to trigger auth modal
  useEffect(() => {
    setAuthPromptCallback(() => {
      promptAuth("Save this? Create a free account.");
    });
  }, [promptAuth]);

  useEffect(() => {
    if (!loading) {
      const onboarded = localStorage.getItem("sovha_onboarded");
      if (!onboarded) setShowOnboarding(true);
    }
  }, [loading]);

  if (loading) {
    return (
      <div className="min-h-screen bg-earth-50 flex items-center justify-center">
        <div className="text-center">
          <img src="/sovha-logo.png" alt="Sovha" className="h-12 mx-auto mb-4" />
          <div className="w-8 h-8 border-2 border-terracotta border-t-transparent rounded-full animate-spin mx-auto" />
        </div>
      </div>
    );
  }

  if (showOnboarding) {
    return (
      <OnboardingFlow onComplete={() => setShowOnboarding(false)} />
    );
  }

  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/check-in" element={<CheckInPage />} />
          <Route path="/calm" element={<CalmToolsPage />} />
          <Route path="/affirmations" element={<AffirmationsPage />} />
          <Route path="/talk" element={<TalkPage />} />
          <Route path="/journal" element={<JournalPage />} />
          <Route path="/understand" element={<UnderstandPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/account" element={<AuthPage />} />
        </Routes>
      </Layout>
      <AuthModal />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
